<div class="row">
    <div #map id="tjaldjup_map" class="olmap" ></div>
</div>
